module.exports = __webpack_public_path__ + "img/blueprint.44a837b3.svg";